module.exports = __webpack_public_path__ + "img/icone-seeding.dcb5c50c.svg";